import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const GallerySlick = ({
	lang,
	dots,
	infinite,
	speed,
	autoplay,
	autoplaySpeed,
	slidesToShow,
	slidesToScroll,
	centerMode,
	centerPadding,
	adaptiveHeight,
	main,
}) => {
	const setting = {
		dots: dots, // 슬라이드 밑에 점 보이게
		infinite: infinite, // 무한으로 반복
		speed: speed, // 넘기는 속도
		variableWidth: false, // variableWidth를 false로 변경
		autoplay: autoplay, // 자동으로 넘김
		autoplaySpeed: autoplaySpeed, //자동으로 넘어가는 속도
		slidesToShow: slidesToShow, // 스크린에 보여지는 슬라이드 개수
		slidesToScroll: slidesToScroll, // n장씩 뒤로 넘어가게 함
		centerMode: centerMode, // 중앙정렬
		centerPadding: centerPadding,
		adaptiveHeight: adaptiveHeight, // 0px 하면 슬라이드 끝쪽 이미지가 안잘림
		// nextArrow: <></>, // 이전 화살표
		// prevArrow: <></>, // 다음 화살표
		responsive: [
			// 반응형 구현 옵션
			{
				breakpoint: 1921,
				settings: {
					centerPadding: '470px',
					dots: true,
				},
			},
			{
				breakpoint: 1920,
				settings: {
					centerPadding: '26%',
					dots: true,
				},
			},
			{
				breakpoint: 767,
				settings: {
					centerPadding: '6%',
				},
			},
		],
		lang, // 한국어페이지인지 영어 페이지인지
		main, // main 페이지인지 아닌지
	};
	return (
		<Slider {...setting}>
			<div className="item">
				<img src="https://image.chosun.com/alc/2025/img1.jpg" />
			</div>
			<div className="item">
				<img src="https://image.chosun.com/alc/2025/img2.jpg" />
			</div>
			<div className="item">
				<img src="https://image.chosun.com/alc/2025/img3.jpg" />
			</div>
			<div className="item">
				<img src="https://image.chosun.com/alc/2025/img4.jpg" />
			</div>
			<div className="item">
				<img src="https://image.chosun.com/alc/2025/img5.jpg" />
			</div>
		</Slider>
	);
};

export default GallerySlick;
